import { useEffect, useRef } from 'react'
import { useTranslation } from 'react-i18next'

/** Tracks whether a data hook has successfully loaded at least once. */
export function useHasLoadedRef() {
  return useRef(false)
}

/** Re-run refresh when UI language changes; pass silent=true after first load. */
export function useRefetchWhenLocaleChanges(
  refresh: (silent?: boolean) => void | Promise<void>,
  hasLoadedRef: React.RefObject<boolean>,
) {
  const { i18n } = useTranslation()
  useEffect(() => {
    void refresh(hasLoadedRef.current)
  }, [refresh, i18n.language, hasLoadedRef])
}

/** Defer non-critical work until after first paint. */
export function runAfterFirstPaint(fn: () => void, timeoutMs = 1500) {
  if (typeof window === 'undefined') {
    fn()
    return
  }
  if ('requestIdleCallback' in window) {
    window.requestIdleCallback(fn, { timeout: timeoutMs })
    return
  }
  globalThis.setTimeout(fn, 0)
}
